import { createTheme } from '@mui/material/styles';
import type { IThemeOptions } from './index';
import { CommonThemeOptions } from './commonTheme';

export const StudioOptions: IThemeOptions = {
  ...CommonThemeOptions,
  themeName: 'Studio',
  components: {
    ...CommonThemeOptions.components,
    MuiButton: {
      styleOverrides: {
        outlinedPrimary: {
          color: '#01AFB5',
          '&.Mui-disabled': {
            color: '#567e80',
            border: '1px solid #567e80',
          },
        },
        containedPrimary: {
          backgroundColor: '#01AFB5',
          '&.Mui-disabled': {
            backgroundColor: '#567e80',
            color: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        primary: {
          color: '#fff',
          backgroundColor: '#01AFB5',
          background: '#01AFB5',
          '&.Mui-disabled': {
            background: '#26282a33',
            color: '#fff',
          },
        },
      },
    },
  },
  palette: {
    ...CommonThemeOptions.palette,
    primary: {
      main: '#01AFB5',
      light: '#04dce3',
      dark: '#029297',
      contrastText: '#fff',
    },
  },
};

export const StudioTheme = createTheme(StudioOptions);
